import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { ISubvendorInvoiceList } from "./Table";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
import { Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";

interface IProps {
    open: boolean,
    tableData: ISubvendorInvoiceList[],
    onHide: () => void,
    toast: any
}

export const ReleasePaymentStatus = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: ISubvendorInvoiceList[], loading: boolean });
    const [selectedSubvendorInvoices, setSelectedSubvendorInvoices] = useState<ISubvendorInvoiceList[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const dt = useRef<any>(null);

    const fromDate = (rowData: any) => {
        let date;
        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const generated_Date = (rowData: any) => {
        let date;
        if (rowData.generated_Date) date = format(new Date(rowData.generated_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const toDate = (rowData: any) => {
        let date;
        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const dueDate = (rowData: any) => {
        let date;
        if (rowData.dueDate) date = format(new Date(rowData.dueDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const paymentDate = (rowData: any) => {
        let date;
        if (rowData.payment_Date) date = format(new Date(rowData.payment_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const onHide = () => {
        setTableData({ tableData: [], loading: false });
        props.onHide();
    }

    const onChangePaymentStatus = async () => {
        let bulkData: ISubvendorInvoiceList[] = [];

        bulkData = selectedSubvendorInvoices.map((invoice: ISubvendorInvoiceList) => ({
            id: invoice.id,
            paymentStatus: "Released",
            paidAmount: 0,
            payment_Mode: null,
            transaction_ID: null,
            deduction: Number(invoice.deduction || 0),
            remarks: invoice.remarks
        }));

        if (bulkData.length > 0) {
            const response = await Fetch("InvoiceTracking/updateBulkPaymentStatusOfSubvendor", "PUT", bulkData, `paymentMode=${"''"}&transaction=${"''"}` + '&inProcess=1', props.toast);

            if (response) {
                props.toast.current.show({ severity: 'success', detail: 'Invoices updated successfully.', life: 3000 });
                onHide();
            }
        } else {
            props.toast.current.show({ severity: 'error', detail: 'Select at least 1 consultant.', life: 3000 });
        }
    };


    useEffect(() => {
        if (props.open && props.tableData) {
            setTableData({ tableData: props.tableData, loading: false });
            setSelectedSubvendorInvoices(props.tableData);
        }
    }, [props.open]);

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Update Payment Status Released" modal className="p-fluid" onHide={onHide}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    ref={dt}
                    value={tableData.tableData}
                    scrollHeight="50vh"
                    loading={tableData.loading}
                    stripedRows resizableColumns showGridlines columnResizeMode="expand"
                    onSelectionChange={(e) => {
                        const value = e.value as ISubvendorInvoiceList[];
                        setSelectedSubvendorInvoices(value);
                    }}
                    selection={selectedSubvendorInvoices}
                    selectionMode="checkbox"
                    dataKey="id"
                >
                    <Column selectionMode="multiple" />
                    <Column header="SN." body={(rowData, options) => options.rowIndex + 1} footer={"Total Amount"} />
                    <Column field="consultant_Name" header="Name" />
                    <Column field="vendor_Company_Name" header="Sub Vendor" />
                    <Column field="invoiceNO" header="Invoice#" />
                    <Column field="invoiceDate" header="Generated Date" body={generated_Date} />
                    <Column field="fromDate" header="From Date" body={fromDate} />
                    <Column field="toDate" header="To Date" body={toDate} />
                    <Column field="dueDate" header="Due Date" body={dueDate} />
                    <Column field="workingHours" header="Hours" />
                    <Column field="bRate" header="B.Rate" />
                    <Column field="invoiceAmount" header="Inv.Amount" footer={() => {
                        const invAmnt = tableData.tableData.reduce((sum, item) => sum + (item.invoiceAmount || 0), 0);
                        return <span className="">{invAmnt}</span>;
                    }} />
                    <Column field="requestedAmount" header="Requested Amount" footer={() => {
                        const reqAmnt = tableData.tableData.reduce((sum, item) => sum + (item.requestedAmount || 0), 0);
                        return <span className="">{reqAmnt}</span>;
                    }} />
                    <Column field="paidAmount" header="Paid Amount" footer={() => {
                        const paidAmnt = tableData.tableData.reduce((sum, item) => sum + (item.paidAmount || 0), 0);
                        return <span className="">{paidAmnt}</span>;
                    }} />
                    <Column field="payment_Mode" header="Payment Mode" />
                    <Column field="transaction_ID" header="Transaction" />
                    <Column field="payment_Date" header="Payment Date" body={paymentDate} />
                    <Column field="paymentStatus" header="Payment Status" body={(rowData) => <p>{rowData.paymentStatus === "-- SELECT --" ? "" : rowData.paymentStatus}</p>} />
                    <Column field="isVerfied" header="Inv Verfied" body={(rowData: any) => <p>{rowData.isVerfied === true ? "Verified" : (rowData.isVerfied === false ? "Rejected" : "Pending")}</p>} />
                    <Column field="aging" header="Aging" />
                    <Column field="primeVendorInvoice" header="PV InvoiceNo" />
                    <Column field="primeVendorPaymentStatus" header="PV PaymentStatus" />
                    <Column field="documentCompleteStatus" header="SV Document Status" body={(rowData) => <p style={rowData.documentCompleteStatus === true ? {} : { color: "red" }}>{rowData.documentCompleteStatus === true ? "Yes" : "No"}</p>} />
                </DataTable>
                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6 h-2rem" label="SAVE" type="button" loading={loading} onClick={() => onChangePaymentStatus()}></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLEAR" type="button"></Button>
                </div>
            </Dialog>
        </>
    );
}